import _ from 'lodash';

const QUALITY = [
  {
    title: undefined,
    legendTitle: 'Bad',
    value: 'Bad',
    icon: 'fas fa-exclamation-circle',
    disabledIcon: 'far fa-exclamation-circle',
    colorClass: 'semantic-bad',
    color: 'var(--bad-color)'
  },
  {
    title: undefined,
    legendTitle: 'Fair',
    value: 'Fair',
    icon: 'fas fa-minus-circle',
    disabledIcon: 'far fa-minus-circle',
    colorClass: 'semantic-fair',
    color: 'var(--fair-color)'
  },
  {
    title: undefined,
    legendTitle: 'Unknown',
    value: 'Unknown',
    icon: 'fas fa-question-circle',
    disabledIcon: 'far fa-question-circle',
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
  {
    title: undefined,
    legendTitle: 'Good',
    value: 'Good',
    icon: 'fas fa-check-circle',
    disabledIcon: 'far fa-check-circle',
    colorClass: 'semantic-good',
    color: 'var(--good-color)'
  },
];

const CALL_TYPE = [
  {
    title: undefined,
    legendTitle: 'Video',
    value: 'Video',
    icon: 'fas fa-camera-web',
    disabledIcon: 'far fa-camera-web',
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
  {
    title: undefined,
    legendTitle: 'Audio',
    value: 'Audio',
    icon: 'fas fa-volume',
    disabledIcon: 'far fa-volume',
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
  {
    title: 'Other',
    legendTitle: 'Other',
    value: 'Other',
    icon: undefined,
    disabledIcon: undefined,
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
];

const CONNECTION = [
  {
    title: undefined,
    legendTitle: 'Wired',
    value: 'Wired',
    icon: 'fas fa-network-wired fa-flip-vertical',
    disabledIcon: 'far fa-network-wired fa-flip-vertical',
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
  {
    title: undefined,
    legendTitle: 'Wifi',
    value: 'Wifi',
    icon: 'fas fa-wifi',
    disabledIcon: 'far fa-wifi',
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
  {
    title: 'Other',
    legendTitle: 'Other',
    value: 'Other',
    icon: undefined,
    disabledIcon: undefined,
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
];

const ENDPOINT_STATUS = [
  {
    title: undefined,
    legendTitle: 'Not Available',
    value: 'NotAvailable',
    icon: 'fas fa-exclamation-circle',
    disabledIcon: 'far fa-exclamation-circle',
    colorClass: 'semantic-bad',
    color: 'var(--bad-color)'
  },
  {
    title: undefined,
    legendTitle: 'None',
    value: 'None',
    icon: 'fas fa-question-circle',
    disabledIcon: 'far fa-question-circle',
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
  {
    title: undefined,
    legendTitle: 'In Call',
    value: 'InCall',
    icon: 'fas fa-circle-phone',
    disabledIcon: 'far fa-circle-phone',
    colorClass: 'semantic-incall',
    color: '#0073b7'
  },
  {
    title: undefined,
    legendTitle: 'Available',
    value: 'Available',
    icon: 'fas fa-check-circle',
    disabledIcon: 'far fa-check-circle',
    colorClass: 'semantic-good',
    color: 'var(--good-color)'
  },
];

const INFRA_STATUS = [
  {
    title: undefined,
    legendTitle: 'Error',
    value: 'Error',
    icon: 'fas fa-exclamation-circle',
    disabledIcon: 'far fa-exclamation-circle',
    colorClass: 'semantic-bad',
    color: 'var(--bad-color)'
  },
  {
    title: undefined,
    legendTitle: 'Unreachable',
    value: 'Unreachable',
    icon: 'fas fa-times-circle',
    disabledIcon: 'far fa-times-circle',
    colorClass: 'semantic-fair',
    color: 'var(--fair-color)'
  },
  {
    title: undefined,
    legendTitle: 'None',
    value: 'None',
    icon: 'fas fa-question-circle',
    disabledIcon: 'far fa-question-circle',
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
  {
    title: undefined,
    legendTitle: 'OK',
    value: 'Ok',
    icon: 'fas fa-check-circle',
    disabledIcon: 'far fa-check-circle',
    colorClass: 'semantic-good',
    color: 'var(--good-color)'
  },
];

const TRUNK_STATUS = [
  {
    title: undefined,
    legendTitle: 'Error',
    value: 'Error',
    icon: 'fas fa-exclamation-circle',
    disabledIcon: 'far fa-exclamation-circle',
    colorClass: 'semantic-bad',
    color: 'var(--bad-color)'
  },
  {
    title: undefined,
    legendTitle: 'Unreachable',
    value: 'Unreachable',
    icon: 'fas fa-times-circle',
    disabledIcon: 'far fa-times-circle',
    colorClass: 'semantic-fair',
    color: 'var(--fair-color)'
  },
  {
    title: undefined,
    legendTitle: 'None',
    value: 'None',
    icon: 'fas fa-question-circle',
    disabledIcon: 'far fa-question-circle',
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
  {
    title: undefined,
    legendTitle: 'OK',
    value: 'OK',
    icon: 'fas fa-check-circle',
    disabledIcon: 'far fa-check-circle',
    colorClass: 'semantic-good',
    color: 'var(--good-color)'
  },
];

const CAMERA = [
  {
    title: undefined,
    legendTitle: 'Not Connected',
    value: 'Bad',
    icon: 'fak fa-solid-camera-web-circle-xmark',
    disabledIcon: 'fak fa-light-camera-web-circle-xmark',
    // svgSrc: 'dist/images/quick-pick/camera-not-conn.svg',
    colorClass: 'semantic-bad',
    color: 'var(--bad-color)'
  },
  {
    title: undefined,
    legendTitle: 'Unknown',
    value: 'Neutral',
    icon: 'fak fa-solid-camera-web-circle-question',
    disabledIcon: 'fak fa-light-camera-web-circle-question',
    // svgSrc: 'dist/images/quick-pick/camera-unknown.svg',
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
  {
    title: undefined,
    legendTitle: 'Connected',
    value: 'Good',
    icon: 'fak fa-solid-camera-web-circle-check',
    disabledIcon: 'fak fa-light-camera-web-circle-check',
    // svgSrc: 'dist/images/quick-pick/camera-conn.svg',
    colorClass: 'semantic-good',
    color: 'var(--good-color)'
  },
];

const DISPLAY = [
  {
    title: undefined,
    legendTitle: 'Not Connected',
    value: 'Bad', 
    icon: 'fak fa-solid-display-circle-xmark',
    disabledIcon: 'fak fa-light-display-circle-xmark',
    // svgSrc: 'dist/images/quick-pick/display-not-conn.svg',
    colorClass: 'semantic-bad',
    color: 'var(--bad-color)'
  },
  {
    title: undefined,
    legendTitle: 'Unknown',
    value: 'Neutral',
    icon: 'fak fa-solid-display-circle-question',
    disabledIcon: 'fak fa-light-display-circle-question',
    // svgSrc: 'dist/images/quick-pick/display-unknown.svg',
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
  {
    title: undefined,
    legendTitle: 'Connected',
    value: 'Good',
    icon: 'fak fa-solid-display-circle-check',
    disabledIcon: 'fak fa-light-display-circle-check',
    // svgSrc: 'dist/images/quick-pick/display-conn.svg',
    colorClass: 'semantic-good',
    color: 'var(--good-color)'
  },
];

const MICROPHONE = [
  {
    title: undefined,
    legendTitle: 'Not Connected',
    value: 'Bad', 
    icon: 'fak fa-solid-microphone-circle-xmark',
    disabledIcon: 'fak fa-light-microphone-circle-xmark',
    // svgSrc: 'dist/images/quick-pick/mic-not-conn.svg',
    colorClass: 'semantic-bad',
    color: 'var(--bad-color)'
  },
  {
    title: undefined,
    legendTitle: 'Unknown',
    value: 'Neutral', 
    icon: 'fak fa-solid-microphone-circle-question',
    disabledIcon: 'fak fa-light-microphone-circle-question',
    // svgSrc: 'dist/images/quick-pick/mic-unknown.svg',
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
  {
    title: undefined,
    legendTitle: 'Connected',
    value: 'Good',
    icon: 'fak fa-solid-microphone-circle-check',
    disabledIcon: 'fak fa-light-microphone-circle-check',
    // svgSrc: 'dist/images/quick-pick/mic-conn.svg',
    colorClass: 'semantic-good',
    color: 'var(--good-color)'
  },
];

const TOUCH_PANEL = [
  {
    title: undefined,
    legendTitle: 'Not Connected',
    value: 'Bad',
    icon: 'fak fa-solid-tablet-screen-circle-xmark',
    disabledIcon: 'fak fa-light-tablet-screen-circle-xmark',
    // svgSrc: 'dist/images/quick-pick/touchpad-not-conn.svg',
    colorClass: 'semantic-bad',
    color: 'var(--bad-color)'
  },
  {
    title: undefined,
    legendTitle: 'Unknown',
    value: 'Neutral',
    icon: 'fak fa-solid-tablet-screen-circle-question',
    disabledIcon: 'fak fa-light-tablet-screen-circle-question',
    // svgSrc: 'dist/images/quick-pick/touchpad-unknown.svg',
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
  {
    title: undefined,
    legendTitle: 'Connected',
    value: 'Good',
    icon: 'fak fa-solid-tablet-screen-circle-check',
    disabledIcon: 'fak fa-light-tablet-screen-circle-check',
    // svgSrc: 'dist/images/quick-pick/touchpad-conn.svg',
    colorClass: 'semantic-good',
    color: 'var(--good-color)'
  },
];

const METRIC_CAMERA_STATUS = [
  {
    title: undefined,
    legendTitle: 'Down',
    value: 'Down',
    icon: 'fak fa-solid-camera-web-circle-xmark',
    disabledIcon: 'fak fa-light-camera-web-circle-xmark',
    colorClass: 'semantic-bad',
    color: 'var(--bad-color)'
  },
  {
    title: undefined,
    legendTitle: 'None',
    value: 'None',
    icon: 'fak fa-solid-camera-web-circle-question',
    disabledIcon: 'fak fa-light-camera-web-circle-question',
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
  {
    title: undefined,
    legendTitle: 'Up',
    value: 'Up',
    icon: 'fak fa-solid-camera-web-circle-check',
    disabledIcon: 'fak fa-light-camera-web-circle-check',
    colorClass: 'semantic-good',
    color: 'var(--good-color)'
  },
];

const METRIC_TOUCH_PANEL_STATUS = [
  {
    title: undefined,
    legendTitle: 'Down',
    value: 'Down',
    icon: 'fak fa-solid-tablet-screen-circle-xmark',
    disabledIcon: 'fak fa-light-tablet-screen-circle-xmark',
    colorClass: 'semantic-bad',
    color: 'var(--bad-color)'
  },
  {
    title: undefined,
    legendTitle: 'None',
    value: 'None',
    icon: 'fak fa-solid-tablet-screen-circle-question',
    disabledIcon: 'fak fa-light-tablet-screen-circle-question',
    colorClass: 'semantic-neutral',
    color: '#6d787e'
  },
  {
    title: undefined,
    legendTitle: 'Up',
    value: 'Up',
    icon: 'fak fa-solid-tablet-screen-circle-check',
    disabledIcon: 'fak fa-light-tablet-screen-circle-check',
    colorClass: 'semantic-good',
    color: 'var(--good-color)'
  },
];

const FILTER_TYPES = {
  call: {
    call_type: CALL_TYPE,
    connection_type: CONNECTION,
    quality: QUALITY,
    avg_quality: QUALITY
  },
  calls: {
    call_type: CALL_TYPE,
    connection_type: CONNECTION,
    quality: QUALITY,
    avg_quality: QUALITY
  },
  endpoints: {
    camera: CAMERA,
    display: DISPLAY,
    microphone: MICROPHONE,
    status: ENDPOINT_STATUS,
    touch_panel: TOUCH_PANEL,
    metric_camera_status: METRIC_CAMERA_STATUS,
    metric_touch_panel_status: METRIC_TOUCH_PANEL_STATUS
  },
  endpoint: {
    status: ENDPOINT_STATUS,
    touch_panel: TOUCH_PANEL,
    metric_camera_status: METRIC_CAMERA_STATUS,
    metric_touch_panel_status: METRIC_TOUCH_PANEL_STATUS
  },
  meeting: {
    quality: QUALITY
  },
  meetings: {
    quality: QUALITY
  },
  systems: {
    status: INFRA_STATUS
  },
  bridges: {
    status: INFRA_STATUS
  },
  callcontrol: {
    status: INFRA_STATUS
  },
  callcontrols: {
    status: INFRA_STATUS
  },
  trunk: {
    status: TRUNK_STATUS
  },
  trunks: {
    status: TRUNK_STATUS
  }
};

// quick pick id require 3 changes 
// - adding a image here, 
// - adding a datasetId to datasetMetadata (add_cpma_dataset_metadata or dataset_metadata)
// - updating getQuickPickType in filter.migration.service
const QUICK_PICK_IMAGES = {
  call: {
    call_type: 'dist/images/quick-pick/qp-call-type.png',
    connection_type: 'dist/images/quick-pick/qp-connection.png',
    endpoint_id: 'dist/images/quick-pick/qp-select-endpoints-mode.png',
    quality: 'dist/images/quick-pick/qp-call-quality.png',
    avg_quality: 'dist/images/quick-pick/qp-call-quality.png'
  },
  calls: {
    call_type: 'dist/images/quick-pick/qp-call-type.png',
    connection_type: 'dist/images/quick-pick/qp-connection.png',
    endpoint_id: 'dist/images/quick-pick/qp-select-endpoints-mode.png',
    quality: 'dist/images/quick-pick/qp-call-quality.png',
    avg_quality: 'dist/images/quick-pick/qp-call-quality.png',
    network_id: 'dist/images/quick-pick/qp-select-networks-mode.png',
  },
  endpoint: {
    endpoint_id: 'dist/images/quick-pick/qp-select-endpoints-mode.png',
    status: 'dist/images/quick-pick/qp-endpoint-status.png',
    metric_camera_status: 'dist/images/quick-pick/qp-camera.png',
    metric_touch_panel_status: 'dist/images/quick-pick/qp-touchpanel.png'
  },
  endpoints: {
    endpoint_id: 'dist/images/quick-pick/qp-select-endpoints-mode.png',
    camera: 'dist/images/quick-pick/qp-camera.png',
    display: 'dist/images/quick-pick/qp-display.png',
    microphone: 'dist/images/quick-pick/qp-microphone.png',
    status: 'dist/images/quick-pick/qp-endpoint-status.png',
    touch_panel: 'dist/images/quick-pick/qp-touchpanel.png',
    metric_camera_status: 'dist/images/quick-pick/qp-camera.png',
    metric_touch_panel_status: 'dist/images/quick-pick/qp-touchpanel.png',
    network_id: 'dist/images/quick-pick/qp-select-networks-mode.png',
  },
  meetings: {
    // calls and meetings quality quick picks look the same
    quality: 'dist/images/quick-pick/qp-call-quality.png',
  },
  meeting: {
    // calls and meetings quality quick picks look the same
    quality: 'dist/images/quick-pick/qp-call-quality.png'
  },
  participants: {
    // calls and meetings quality quick picks look the same
    quality: 'dist/images/quick-pick/qp-call-quality.png',
    network_id: 'dist/images/quick-pick/qp-select-networks-mode.png',
  },
  systems: {
    // systems and trunks status quick picks look the same
    status: 'dist/images/quick-pick/qp-trunks-status.png',
    system_id: 'dist/images/quick-pick/qp-select-systems-mode.png'
  },
  bridges: {
    // systems and trunks status quick picks look the same
    status: 'dist/images/quick-pick/qp-trunks-status.png',
    system_id: 'dist/images/quick-pick/qp-select-bridges-mode.png'
  },
  callcontrol: {
    // systems and trunks status quick picks look the same
    status: 'dist/images/quick-pick/qp-trunks-status.png',
    system_id: 'dist/images/quick-pick/qp-select-callcontrols-mode.png'
  },
  callcontrols: {
    // systems and trunks status quick picks look the same
    status: 'dist/images/quick-pick/qp-trunks-status.png',
    system_id: 'dist/images/quick-pick/qp-select-callcontrols-mode.png'
  },
  trunks: {
    status: 'dist/images/quick-pick/qp-trunks-status.png',
    trunk_id: 'dist/images/quick-pick/qp-select-trunks-mode.png'
  },
  trunk: {
    status: 'dist/images/quick-pick/qp-trunks-status.png',
    trunk_id: 'dist/images/quick-pick/qp-select-trunks-mode.png'
  },
  spaces: {
    'van_room.buildingKey': 'dist/images/quick-pick/qp-select-buildings-mode.png',
  },
  networks: {
    'network.buildingKey': 'dist/images/quick-pick/qp-select-buildings-mode.png',
    'dimipsubnet.dimipsubnetsid': 'dist/images/quick-pick/qp-select-networks-mode.png',
  },
  'summaryview.networkInsightsDetail': {
    'dimbuilding.buildingkey': 'dist/images/quick-pick/qp-select-buildings-mode.png',
    'dimipsubnet.dimipsubnetsid': 'dist/images/quick-pick/qp-select-networks-mode.png',
  }
};

export default {
  getFilterTypes: function() {
    return _.cloneDeep(FILTER_TYPES);
  },

  getImageMap: function() {
    return _.cloneDeep(QUICK_PICK_IMAGES);
  }
};
